import webClient from "../config/api.config";
import {
  ManagerPageQuery,
  ManagerRequest,
  ManagerUpdate,
} from "../types/manager.definition";
export function getManagerById(managerId: string) {
  return webClient.request({
    method: "get",
    url: `managers/${managerId}`,
  });
}
export function updateManager(managerId: string, data: ManagerUpdate) {
  return webClient.request({
    method: "put",
    url: `managers/${managerId}`,
    data,
  });
}
export function getManagerAvailabilities(managerId: string) {
  return webClient.request({
    method: "get",
    url: `manager-availability/${managerId}`,
  });
}

export function createManager(data: ManagerRequest) {
  return webClient.request({
    method: "post",
    url: `managers/register`,
    data,
  });
}

export function getAllManagers() {
  return webClient.request({
    method: "get",
    url: `managers`,
  });
}

/** MED-1635: one server-side page of managers (search, assigned filter, sort). */
export function getManagersPage(params: ManagerPageQuery) {
  return webClient.request({
    method: "get",
    url: `managers/page`,
    params,
  });
}

/**
 * MED-1631: links an existing manager to a facility (onboarding, facility detail).
 * `PUT /managers/{id}` silently ignored the facility (the API update payload only
 * carries `user`), so the dedicated route is used.
 */
export function assignManagerToFacility(facilityId: number, managerId: number) {
  return assignManagerFacility(managerId, facilityId);
}

/**
 * MED-1470: assign the manager to a facility through the dedicated gateway route
 * (`PUT /managers/{id}/facility/{facilityId}`).
 */
export function assignManagerFacility(managerId: number, facilityId: number) {
  return webClient.request({
    method: "put",
    url: `managers/${managerId}/facility/${facilityId}`,
  });
}

/** MED-1470: detach the manager from their facility; the account stays enabled. */
export function unassignManagerFacility(managerId: number) {
  return webClient.request({
    method: "delete",
    url: `managers/${managerId}/facility`,
  });
}

/** MED-1470/MED-1472: soft-disable the manager account (it is never erased). */
export function disableManager(managerId: number) {
  return webClient.request({
    method: "delete",
    url: `managers/${managerId}`,
  });
}

/** MED-1472: re-enable a manager account previously disabled. */
export function restoreManager(managerId: number) {
  return webClient.request({
    method: "put",
    url: `managers/${managerId}/restore`,
  });
}
